<template>
  <div :class="$style.modal">
    <div :class="$style.modalContent">
      <ModalHeader
        :handleClose="handleClose"
        headerText="Unable to Add Credit Card Information"
        :showClose="true"
      />
      <div :class="$style.modalBody">
        <p>
          You can only manage payments from the Multi-Tenant Portal menu.
        </p>
      </div>
      <ModalFooter
        cancelText=""
        :handleClose="handleClose"
        :handleMainAction="handleClose"
        mainActionText="ok"
      />
    </div>
  </div>
</template>

<script>
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import ModalFooter from 'client/components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'client/components/Modal/ModalComponents/ModalHeader.vue';

export default {
  name: 'OnlyAllowProviderPaymentsModal',

  components: {
    ModalFooter,
    ModalHeader,
  },

  methods: {
    handleClose() {
      ModalEventBus.close();
    },
  },
};
</script>

<style module>
@import '../Modal/css/ModalStyles.css';
</style>
